<template>
  <main class="about-content">
    <header>
      <Headermenu :menu-color="'aboutus'"
                  :is-home="false"></Headermenu>
    </header>

    <!-- 主标题 - 页面唯一的 h1 -->
    <h1 class="visually-hidden">{{ $t('home.AboutUs.aboutTitle') }} - Flashbase</h1>

    <!-- 头部横幅 -->
    <section class="header"
             aria-label="关于我们横幅"></section>

    <section class="content">
      <!-- 公司介绍 -->
      <article class="about-desc">
        <h2 class="about-title">{{ $t('home.AboutUs.aboutTitle') }}</h2>
        <p class="about-entitle">ABOUT FLASHBASE</p>
        <p class="about-subtitle">
          {{ $t('home.AboutUs.aboutSubTitle1') }}<br>
          {{ $t('home.AboutUs.aboutSubTitle2') }}<br>
          {{ $t('home.AboutUs.aboutSubTitle3') }}<br>
          {{ $t('home.AboutUs.aboutSubTitle4') }}</p>
        <div class="about-img"
             aria-hidden="true"></div>
      </article>

      <!-- 服务优势 -->
      <section class="about-rail"
               aria-label="我们的服务优势">
        <div class="about-rail-content"
             role="list">
          <article v-for="(item, index) in about_content"
                   :key="index"
                   class="about-rail-item"
                   role="listitem">
            <div class="about-rail-top">
              <div :style="{ background: `url(${item.icon}) no-repeat`, backgroundSize: 'contain' }"
                   class="icon"
                   aria-hidden="true"></div>
              <div :style="{ backgroundColor: `${item.boxShadowColor}` }"
                   class="box-round">
                <div :style="{ backgroundColor: `${item.color}` }"
                     class="box-round-item"
                     aria-hidden="true"></div>
              </div>
            </div>
            <h3 class="about-rail-name">{{ item.name }}</h3>
            <p class="about-rail-desc">{{ item.desc }}</p>
          </article>
        </div>
      </section>

      <!-- 工厂展示 -->
      <section class="about-factory"
               aria-label="工厂区域展示">
        <div class="factory-desc">
          <h2 class="factory-desc-title">{{ $t('home.AboutUs.aboutFactory') }}</h2>
          <p class="factory-desc-entitle">FACTORY AREA DISPLAY</p>
          <p class="factory-desc-subtitle">{{ $t('home.AboutUs.factorySubTitle') }}</p>
        </div>
        <div class="factory-content"
             role="list">
          <article v-for="(item, index) in factory_content"
                   :key="index"
                   :style="{ background: `url(${item.img})` }"
                   class="factory-content-item"
                   role="listitem">
            <h3 class="factory-content-name">{{ item.name }}</h3>
          </article>
        </div>
        <div class="factory-bg"
             aria-hidden="true"></div>
      </section>
    </section>

    <!-- 页脚 -->
    <footer>
      <Footer></Footer>
    </footer>
  </main>
</template>

<script setup lang="ts">
import Headermenu from "./components/HeaderMenu.vue"
import Footer from "./components/Footer.vue"
import ic_factory from '../assets/imgs/ic_factory.png'
import ic_invoice from '../assets/imgs/ic_invoice.png'
import ic_sendout from '../assets/imgs/ic_sendout.png'
import inventory from '../assets/imgs/inventory.png'
import fabric from '../assets/imgs/fabric.png'
import inspection from '../assets/imgs/inspection.png'
import embroidery from '../assets/imgs/embroidery.png'
import digital from '../assets/imgs/digital.png'
import screenprint from '../assets/imgs/screenprint.png'
import { useI18n } from "vue-i18n"
import { computed } from "vue"
import { updateSeo } from "&/utils/seo"
import { usePageSeo } from "&/composables/useSeoMeta"

// 设置SEO元数据
usePageSeo('about')

const { t } = useI18n()
const about_content = computed(() => [
  {
    name: t('home.AboutUs.about_ic_factory'),
    icon: ic_factory,
    desc: t('home.AboutUs.about_ic_factory_desc'),
    color: '#D12F2F',
    boxShadowColor: "rgba(209, 47, 47, 0.15)"
  },
  {
    name: t('home.AboutUs.about_ic_sendout'),
    icon: ic_sendout,
    desc: t('home.AboutUs.about_ic_sendout_desc'),
    color: '#E89E00',
    boxShadowColor: "rgba(232, 158, 0, 0.15)"
  },
  {
    name: t('home.AboutUs.about_ic_invoice'),
    icon: ic_invoice,
    desc: t('home.AboutUs.about_ic_invoice_desc'),
    color: '#21C164',
    boxShadowColor: "rgba(33, 193, 100, 0.15)"
  },
])
const factory_content = computed(() => [
  {
    name: t('home.AboutUs.factory_inventory'),
    img: inventory
  },
  {
    name: t('home.AboutUs.factory_fabric'),
    img: fabric
  },
  {
    name: t('home.AboutUs.factory_inspection'),
    img: inspection
  },
  {
    name: t('home.AboutUs.factory_embroidery'),
    img: embroidery
  },
  {
    name: t('home.AboutUs.factory_digital'),
    img: digital
  },
  {
    name: t('home.AboutUs.factory_screenprint'),
    img: screenprint
  },
])
</script>

<style scoped lang="less">
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.about-content {
  height: 100%;
  overflow: auto;

  .header {
    width: 100%;
    height: 600px;
    background: url('../assets/imgs/about_banner.png') center no-repeat;
    background-size: cover;
    background-color: #111111;

    img {
      width: 100%;
      height: 600px;
    }
  }

  .content {
    background-color: #f6f6f6;

    .about-desc {
      position: relative;
      height: 620px;
      padding: 100px 0 0 260px;

      .about-title {
        font-size: 40px;
        font-weight: bold;
        color: #111111;
      }

      .about-entitle {
        font-size: 14px;
        color: #999999;
      }

      .about-subtitle {
        font-size: 24px;
        line-height: 48px;
        color: #111111;
        margin-top: 60px;
      }

      .about-img {
        width: 988px;
        height: 572px;
        background: url('../assets/imgs/bg_building.png') no-repeat center/cover;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }

    .about-rail {
      height: 200px;
      background: url('../assets/imgs/bg_rail.png') no-repeat center/cover;
      background-size: 100% 100%;
      position: relative;

      .about-rail-content {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0 260px;
        position: absolute;
        top: -150px;
        left: 0;

        .about-rail-item {
          width: 440px;
          height: 250px;
          box-shadow: 0px 10px 46px 0px rgba(0, 0, 0, 0.06);
          background-color: #fff;
          padding: 0 40px;

          .about-rail-top {
            height: 152px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .icon {
              width: 60px;
              height: 60px;
            }

            .box-round {
              position: relative;
              width: 30px;
              height: 30px;
              border-radius: 50%;

              .box-round-item {
                width: 12px;
                height: 12px;
                position: absolute;
                bottom: 9px;
                left: 9px;
                border-radius: 50%;
              }
            }
          }

          .about-rail-name {
            height: 52px;
            line-height: 52px;
            font-size: 18px;
            font-weight: bold;
            color: #111111;
          }

          .about-rail-desc {
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }

    .about-factory {
      height: 1000px;
      position: relative;

      .factory-desc {
        text-align: center;

        .factory-desc-title {
          margin-top: 100px;
          font-size: 40px;
          font-weight: bold;
          color: #111111;
        }

        .factory-desc-entitle {
          font-size: 14px;
          margin-top: 10px;
          color: #999999;
        }

        .factory-desc-subtitle {
          margin-top: 40px;
          font-size: 24px;
          color: #111111;
        }
      }

      .factory-content {
        margin: 60px 260px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        row-gap: 20px;
        column-gap: 40px;
        flex-direction: row;

        .factory-content-item {
          width: 30%;
          background-size: cover !important;
          background-position: center !important;
          text-align: center;

          .factory-content-name {
            width: 100%;
            height: 80px;
            line-height: 80px;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
            font-size: 24px;
            font-weight: bold;
            color: #FFFFFF;
            margin-top: 220px;
          }
        }
      }

      .factory-bg {
        width: 927px;
        height: 774px;
        background: url('../assets/imgs/bg_fabric.png') no-repeat;
        background-size: cover;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
}
</style>
